// Module
var code = `<form name="\$ctrl.formName" novalidate>
  <table class="table table--generate-row-ids">
    <thead>
    <th>No.</th>
    <th>Name</th>
    <th>Outstanding balance</th>
    <th>Waive</th>
    <th></th>
    <th>Final balance to pay</th>
    </thead>
    <tbody class="tbody">
    <tr>
      <td></td>
      <td>Total Principal</td>
      <td>
        <cash ng-model="\$ctrl.maxValues.principal"
              ng-disabled="true"></cash>
      </td>
      <td>
        <cash ng-model="\$ctrl.waived.principal"
              ng-disabled="true"></cash>
      </td>
      <td></td>
      <td>
        <cash ng-model="\$ctrl.finalValues.principal"
              ng-disabled="true"></cash>
      </td>
    </tr>
    <tr ng-if="!\$ctrl.isAsEarned">
      <td></td>
      <td>Total Interest</td>
      <td>
        <cash ng-model="\$ctrl.maxValues.interest"
              ng-disabled="true"></cash>
      </td>
      <td>
        <cash ng-model="\$ctrl.waived.interest"
              max="\$ctrl.maxValues.interest"></cash>
      </td>
      <td></td>
      <td>
        <cash ng-model="\$ctrl.finalValues.interest"
              ng-disabled="true"></cash>
      </td>
    </tr>
    <tr ng-if="\$ctrl.isAsEarned">
      <td></td>
      <td>Total Interest (As Earned)</td>
      <td>
        <glue-container append="'total ' + \$ctrl.maxValues.interest + ' PHP'">
        <cash ng-model="\$ctrl.asEarnedInterest"
              ng-disabled="true"></cash>
        </glue-container>
      </td>
      <td>
        <cash ng-model="\$ctrl.waived.interest"
              max="\$ctrl.maxValues.interest"
              min="\$ctrl.asEarnedAutomaticWaiveAmount"></cash>
      </td>
      <td>
        <help title="At least the amount of unearned interest {{\$ctrl.asEarnedAutomaticWaiveAmount | nxCurrency}} must be waived."></help>
      </td>
      <td>
        <cash ng-model="\$ctrl.finalValues.interest"
              ng-disabled="true"></cash>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Total CBU</td>
      <td>
        <cash ng-model="\$ctrl.maxValues.cbuCharge"
              ng-disabled="true"></cash>
      </td>
      <td>
        <cash ng-model="\$ctrl.waived.cbu"
              max="\$ctrl.maxValues.cbuCharge"></cash>
      </td>
      <td></td>
      <td>
        <cash ng-model="\$ctrl.finalValues.cbu"
              ng-disabled="true"></cash>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Total PF</td>
      <td>
        <cash ng-model="\$ctrl.maxValues.pfCharge"
              ng-disabled="true"></cash>
      </td>
      <td>
        <cash ng-model="\$ctrl.waived.pf"
              max="\$ctrl.maxValues.pfCharge"></cash>
      </td>
      <td></td>
      <td>
        <cash ng-model="\$ctrl.finalValues.pf"
              ng-disabled="true"></cash>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Total TP</td>
      <td>
        <cash ng-model="\$ctrl.maxValues.tpCharge"
              ng-disabled="true"></cash>
      </td>
      <td>
        <cash ng-model="\$ctrl.waived.tp"
              max="\$ctrl.maxValues.tpCharge"></cash>
      </td>
      <td></td>
      <td>
        <cash ng-model="\$ctrl.finalValues.tp"
              ng-disabled="true"></cash>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Total Past-due interest</td>
      <td>
        <cash ng-model="\$ctrl.maxValues.pastDueInterestWithMaturity"
              ng-disabled="true"></cash>
      </td>
      <td>
        <cash ng-model="\$ctrl.waived.pastDueInterestWithMaturity"
              max="\$ctrl.maxValues.pastDueInterestWithMaturity"></cash>
      </td>
      <td></td>
      <td>
        <cash ng-model="\$ctrl.finalValues.pastDueInterestWithMaturity"
              ng-disabled="true"></cash>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Total Penalties</td>
      <td>
        <cash ng-model="\$ctrl.maxValues.penaltyWithMaturity"
              ng-disabled="true"></cash>
      </td>
      <td>
        <cash ng-model="\$ctrl.waived.penaltyWithMaturity"
              max="\$ctrl.maxValues.penaltyWithMaturity"></cash>
      </td>
      <td></td>
      <td>
        <cash ng-model="\$ctrl.finalValues.penaltyWithMaturity"
              ng-disabled="true"></cash>
      </td>
    </tr>

    <tr ng-repeat="item in \$ctrl.customFees">
      <td></td>
      <td>{{item.feeName}}</td>
      <td>
        <cash ng-model="item.balance"
              ng-disabled="true"></cash>
      </td>
      <td>
        <cash ng-model="item.waiveAmount"
              ng-change="\$ctrl.updateCustomFeesParams()"
              max="item.balance"></cash>
      </td>
      <td></td>
      <td>
        <cash ng-model="item.finalBalance"
              ng-disabled="true"
              max="item.balance"></cash>
      </td>
    </tr>

    <tr>
      <td></td>
      <td>Total amount:</td>
      <td>
        <cash ng-model="\$ctrl.waiveRequest.total.totalOutstandingBalance"
              ng-disabled="true"></cash>
      </td>
      <td>
        <cash ng-model="\$ctrl.waiveRequest.total.totalWaive"
              ng-disabled="true"></cash>
      </td>
      <td></td>
      <td>
        <cash ng-model="\$ctrl.waiveRequest.total.totalFinalBalanceToPay"
              ng-disabled="true"></cash>
      </td>
    </tr>

    <tr ng-if="\$ctrl.collectOfficialReceipt">
      <td>&nbsp;</td>
      <td colspan="4">Invoice:</td>
      <td>
        <input type="text"
               ng-model="\$ctrl.officialReceipt"
               required>
      </td>
    </tr>
    </tbody>
  </table>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/common/loan-pre-terminate.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;